import { List, Button } from "antd";
import { UpOutlined, DownOutlined } from "@ant-design/icons";

import useCreate from "hooks/useCreate";
import useDelete from "hooks/useDelete";
import ModalDelete from "components/ModalDelete";

const Item = ({ id, position, content, refetch, is_first, is_last }) => {
  const { is_saving: is_saving_move_up, create: moveUp } = useCreate({
    path: `/custom_comments/${id}/move_up`,
    onSuccess: refetch,
    success_message: "Przeniesiono w górę",
  });

  const { is_saving: is_saving_move_down, create: moveDown } = useCreate({
    path: `/custom_comments/${id}/move_down`,
    onSuccess: refetch,
    success_message: "Przeniesiono w dół",
  });

  const { is_deleting, _delete } = useDelete({
    path: `/custom_comments/${id}`,
    onSuccess: refetch,
  });

  return (
    <List.Item
      key={id}
      actions={[
        <Button
          loading={is_saving_move_up}
          disabled={is_first}
          onClick={() => moveUp()}
          type="primary"
          ghost
          icon={<UpOutlined />}
          size="small"
        />,
        <Button
          disabled={is_last}
          onClick={() => moveDown()}
          type="primary"
          ghost
          loading={is_saving_move_down}
          icon={<DownOutlined />}
          size="small"
        />,
        <ModalDelete
          only_icon
          loading={is_deleting}
          text={<strong>{content}</strong>}
          handleDelete={() => _delete()}
          button_size="small"
        />,
      ]}
    >
      {position}. {content}
    </List.Item>
  );
};

export default Item;
